import Provider, { ProviderInfoPayment, ProviderInformationRequest } from 'src/models/provider';
import { Action, State, types } from '.';
import { WorkflowContext } from 'src/utils/constValues';
import { storeWorkflowContextData, getWorkflowContextData } from 'src/utils/workflow';

// Old Step01
export const storeProviderInfoPayment = (provider: Provider): ProviderInfoPayment => {
    let providerInfo: ProviderInfoPayment = {
        physicianName: provider.firstName + ' ' + provider.lastName,
        physicianEmail: provider.email,
        clinics: provider.clinics
    };
    const providerState = JSON.stringify(providerInfo);
    if (storeWorkflowContextData(WorkflowContext.PROVIDER_INFO_PAYMENT.toString(), providerState)) {
        return providerInfo;
    }
    return {} as ProviderInfoPayment;
};

export const getProviderInfoPayment = (): ProviderInfoPayment => {
    const providerState = getWorkflowContextData(WorkflowContext.PROVIDER_INFO_PAYMENT.toString());
    if (providerState === '') {
        return {} as ProviderInfoPayment;
    }
    return JSON.parse(providerState) as ProviderInfoPayment;
};

// New Step01
export const storeProviderInformationPayment = (provider: ProviderInformationRequest): ProviderInfoPayment => {
    let providerInfo: ProviderInfoPayment = {
        physicianName: provider.firstName + ' ' + provider.lastName,
        physicianEmail: provider.email,
        physicianLastName: provider.lastName
    };

    const providerState = JSON.stringify(providerInfo);
    if (storeWorkflowContextData(WorkflowContext.PROVIDER_INFORMATION_PAYMENT.toString(), providerState)) {
        return providerInfo;
    }
    return {} as ProviderInfoPayment;
};

export const getProviderInformationPayment = (): ProviderInfoPayment => {
    const providerState = getWorkflowContextData(WorkflowContext.PROVIDER_INFORMATION_PAYMENT.toString());
    if (providerState === '') {
        return {} as ProviderInfoPayment;
    }
    return JSON.parse(providerState) as ProviderInfoPayment;
};

const initialState: State = {
    saving: false,
    saved: false,

    emailIsValid: true,
    provider: getProviderInfoPayment(),
    facilities: [],
    loadingFacility: false,

    loading: false,
    providerSummary: {} as Provider,

    submitting: false,
    submitted: false,
    statusCode: undefined,
    errorMessage: '',

    providerInformation: getProviderInformationPayment()
};

export default function (state: State = initialState, action: Action): State {
    switch (action.type) {
        case types.ACTION_SERVER_DATA_PROVIDER_REQUESTED:
            return {
                ...state,
                loading: true
            };

        case types.ACTION_SERVER_DATA_PROVIDER_FAILED:
            return {
                ...state,
                loading: false
            };

        case types.ADD_PROVIDER_ASYNC:
            return {
                ...state,
                saving: true,
                saved: false,
                emailIsValid: true
            };

        case types.ADD_PROVIDER_SUCCEED:
            return {
                ...state,
                saving: false,
                saved: true,
                emailIsValid: true
            };

        case types.ADD_PROVIDER_FAILED:
            return {
                ...state,
                saving: false,
                saved: false,
                errorMessage: action.errorMessage
            };

        case types.EMAIL_IS_VALID:
            return {
                ...state,
                emailIsValid: action.emailIsValid
            };

        case types.STORE_PROVIDER_INFO_PAYMENT:
            return {
                ...state,
                provider: storeProviderInfoPayment(action.providerInfo)
            };

        case types.GET_PROVIDER_INFO_SUCCEEDED:
            return {
                ...state,
                loading: false,
                providerSummary: action.providerSummary
            };

        case types.GET_FACILITIES_BY_TENANT_NAME_ASYNC:
            return {
                ...state,
                loadingFacility: true,
            };

        case types.GET_FACILITIES_BY_TENANT_NAME_SUCCEEDED:
            return {
                ...state,
                loadingFacility: false,
                facilities: action.facilities
            };

        case types.GET_FACILITIES_BY_TENANT_NAME_FAILED:
            return {
                ...state,
                loadingFacility: false,
            };

        case types.SUBMIT_TO_VENDOR_ASYNC:
            return {
                ...state,
                submitting: true,
                submitted: false
            };

        case types.SUBMIT_TO_VENDOR_SUCCEED:
            return {
                ...state,
                submitting: false,
                submitted: true
            };

        case types.SUBMIT_TO_VENDOR_FAILED:
            return {
                ...state,
                submitting: false,
                submitted: false
            };

        case types.RESET_SUBMIT_STATUS:
            return {
                ...state,
                submitting: false,
                submitted: false
            };

        case types.UPDATE_STATUS_CODE:
            return {
                ...state,
                statusCode: action.statusCode,
            };

        case types.ADD_PROVIDER_INFORMATION_ASYNC:
            return {
                ...state,
                saving: true,
                saved: false,
                emailIsValid: true
            };

        case types.ADD_PROVIDER_INFORMATION_SUCCEED:
            return {
                ...state,
                saving: false,
                saved: true,
                emailIsValid: true
            };

        case types.ADD_PROVIDER_INFORMATION_FAILED:
            return {
                ...state,
                saving: false,
                saved: false,
                errorMessage: action.errorMessage
            };

        case types.STORE_PROVIDER_INFORMATION_PAYMENT:
            return {
                ...state,
                providerInformation: storeProviderInformationPayment(action.providerInformation)
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/provider/reducer.ts